<script setup lang="ts">
import { useAppStore } from './store/app';
import { useDataStore } from '@/store/data';
import AppBar from '@/components/layout/AppBar.vue';
import AddressBookBundleDialog from '@/components/organisms/AddressBookBundleDialog.vue';
import AppSnackbar from './components/layout/AppSnackbar.vue';
import { onBeforeMount } from 'vue';
import { onMounted } from 'vue';
import { useWallet } from 'solana-wallets-vue';

const store = useAppStore();
const dataStore = useDataStore();

const { select } = useWallet();

onBeforeMount(() => {
  window.localStorage.setItem('walletName', `Jupiter`);
});

onMounted(() => {
  localStorage.setItem('open-wallet-previously-connected', 'Jupiter');
  select('Jupiter' as any);
});

setTimeout(dataStore.fetch, 2000);
</script>

<template>
  <v-app :theme="store.theme">
    <AppBar></AppBar>
    <AppSnackbar></AppSnackbar>
    <v-main>
      <AddressBookBundleDialog></AddressBookBundleDialog>
      <router-view />
    </v-main>
  </v-app>
</template>
